'use client';

import { useStore } from '@/stores';

/**
 * Hook to get the current active organization from the zustand store
 * @returns {currentStore} - The current active organization
 */
function useCurrentActiveOrg() {
  const currentStore = useStore((state) => state.currentStore);
  return { currentStore };
}

export { useCurrentActiveOrg };
